import { OverlayRef } from '@angular/cdk/overlay';
import { ReplaySubject, Subject } from 'rxjs';
import { TemplateRef, Type } from '@angular/core';

export interface PopoverCloseEvent<T = any> {
  type: 'backdropClick' | 'close' | 'submit';
  data: T;
}

export type PopoverContent = TemplateRef<any> | Type<any> | string | any;

export class PopoverRef<T = any> {
  private afterClosed = new Subject<PopoverCloseEvent<T>>();
  afterClosed$ = this.afterClosed.asObservable();
  changedData$: ReplaySubject<any> = new ReplaySubject<any>();

  constructor(
    public overlay: OverlayRef,
    public content: PopoverContent,
    public data: T) {
    overlay.backdropClick().subscribe(() => {
      this._close('backdropClick', null);
    });
  }

  close(data?: T, type: PopoverCloseEvent['type'] = 'close') {
    this._close(type, data);
  }

  private _close(type: PopoverCloseEvent['type'], data?: T) {
    this.overlay.dispose();
    this.afterClosed.next({
      type,
      data
    });
    this.afterClosed.complete();
  }
}
